import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import BridgeContext, { defaultState } from './context';

var Bridge = /*#__PURE__*/function (_React$Component) {
  _inherits(Bridge, _React$Component);

  var _super = _createSuper(Bridge);

  function Bridge() {
    var _this;

    _classCallCheck(this, Bridge);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread(_objectSpread({}, defaultState), {}, {
      auth: _this.props.auth
    }));

    _defineProperty(_assertThisInitialized(_this), "setRequiresAuth", function (requiresAuth) {
      _this.setState({
        requiresAuth: requiresAuth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSignIn", function (user) {
      var onSignIn = _this.props.onSignIn;
      var signedIn = _this.state.signedIn;

      if (signedIn) {
        return;
      }

      _this.setState({
        signedIn: true
      }, function () {
        if (typeof onSignIn === 'function') {
          onSignIn(user);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSignOut", function () {
      var onSignOut = _this.props.onSignOut;
      var signedIn = _this.state.signedIn;

      if (!signedIn) {
        return;
      }

      _this.setState({
        signedIn: false
      }, function () {
        if (typeof onSignOut === 'function') {
          onSignOut();
        }
      });
    });

    return _this;
  }

  _createClass(Bridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var auth = this.state.auth;
      var _this$props = this.props,
          onSignInNeeded = _this$props.onSignInNeeded,
          onAuthStateChange = _this$props.onAuthStateChange,
          onSetLocation = _this$props.onSetLocation,
          onSignInError = _this$props.onSignInError,
          onSignOutError = _this$props.onSignOutError,
          onSessionExpired = _this$props.onSessionExpired,
          onSessionExpiring = _this$props.onSessionExpiring;

      if (!auth) {
        return;
      }

      auth.events.signInNeeded.on(onSignInNeeded);
      auth.events.signIn.on(this.handleSignIn);
      auth.events.signOut.on(this.handleSignOut);
      auth.events.stateChange.on(onAuthStateChange);
      auth.events.setLocation.on(onSetLocation);
      auth.events.signInError.on(onSignInError);
      auth.events.signOutError.on(onSignOutError);
      auth.events.sessionExpired.on(onSessionExpired);
      auth.events.sessionExpiring.on(onSessionExpiring);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var auth = this.state.auth;
      var _this$props2 = this.props,
          onSignInNeeded = _this$props2.onSignInNeeded,
          onAuthStateChange = _this$props2.onAuthStateChange,
          onSetLocation = _this$props2.onSetLocation,
          onSignInError = _this$props2.onSignInError,
          onSignOutError = _this$props2.onSignOutError,
          onSessionExpired = _this$props2.onSessionExpired,
          onSessionExpiring = _this$props2.onSessionExpiring;

      if (!auth) {
        return;
      }

      auth.events.signInNeeded.off(onSignInNeeded);
      auth.events.signIn.off(this.handleSignIn);
      auth.events.signOut.off(this.handleSignOut);
      auth.events.stateChange.off(onAuthStateChange);
      auth.events.setLocation.off(onSetLocation);
      auth.events.signInError.off(onSignInError);
      auth.events.signOutError.off(onSignOutError);
      auth.events.sessionExpired.off(onSessionExpired);
      auth.events.sessionExpiring.off(onSessionExpiring);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          auth = _this$state.auth,
          requiresAuth = _this$state.requiresAuth,
          signedIn = _this$state.signedIn; // if it's auth url, don't render children

      if (Bridge.isAuthUrl(auth)) {
        return this.renderNotAuthenticated();
      } // if auth is required and we are not signed in, don't render children


      if (requiresAuth && !signedIn) {
        return this.renderNotAuthenticated();
      } // otherwise, the user is signed in OR auth is not requiresd so render children


      return /*#__PURE__*/React.createElement(BridgeContext.Provider, {
        value: {
          auth: auth,
          requiresAuth: requiresAuth,
          signedIn: signedIn,
          setRequiresAuth: this.setRequiresAuth
        }
      }, children);
    }
  }, {
    key: "renderNotAuthenticated",
    value: function renderNotAuthenticated(loading) {
      var renderNotAuthenticated = this.props.renderNotAuthenticated;

      if (typeof renderNotAuthenticated === 'function') {
        return renderNotAuthenticated(loading);
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.requiresAuth !== state.requiresAuth) {
        var requiresAuth = typeof state.requiresAuth !== 'boolean' ? props.requiresAuth : state.requiresAuth;
        var auth = state.auth || props.auth;

        if (!state.signedIn) {
          Bridge.startOrContinueFlow({
            auth: auth,
            requiresAuth: requiresAuth
          });
        }

        return {
          requiresAuth: requiresAuth
        };
      }

      return null;
    }
  }]);

  return Bridge;
}(React.Component);

_class = Bridge;

_defineProperty(Bridge, "propTypes", {
  auth: PropTypes.object.isRequired,
  requiresAuth: PropTypes.bool,
  onSignInNeeded: PropTypes.func,
  onSignIn: PropTypes.func,
  onSignInError: PropTypes.func,
  onSignOut: PropTypes.func,
  onSignOutError: PropTypes.func,
  onAuthStateChange: PropTypes.func,
  onSetLocation: PropTypes.func,
  onSessionExpired: PropTypes.func,
  children: PropTypes.node,
  renderNotAuthenticated: PropTypes.func
});

_defineProperty(Bridge, "defaultProps", {
  requiresAuth: true
});

_defineProperty(Bridge, "startOrContinueFlow", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var auth, requiresAuth, ssoToken, session;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth, requiresAuth = _ref.requiresAuth;

          if (auth) {
            _context.next = 4;
            break;
          }

          console.error('auth prop is required to sign in');
          return _context.abrupt("return");

        case 4:
          if (!_class.isAuthUrl(auth)) {
            _context.next = 8;
            break;
          }

          _context.next = 7;
          return auth.resume();

        case 7:
          return _context.abrupt("return", _context.sent);

        case 8:
          // if there is an sso token, try to sign in with that
          ssoToken = auth.getSSOToken();

          if (!ssoToken) {
            _context.next = 13;
            break;
          }

          _context.next = 12;
          return auth.signIn();

        case 12:
          return _context.abrupt("return", _context.sent);

        case 13:
          _context.next = 15;
          return auth.getSession();

        case 15:
          session = _context.sent;

          if (!session) {
            _context.next = 20;
            break;
          }

          _context.next = 19;
          return auth.resume(session, requiresAuth);

        case 19:
          return _context.abrupt("return", _context.sent);

        case 20:
          if (!requiresAuth) {
            _context.next = 24;
            break;
          }

          _context.next = 23;
          return auth.signIn();

        case 23:
          return _context.abrupt("return", _context.sent);

        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

_defineProperty(Bridge, "isAuthUrl", function (auth) {
  return auth && auth.isAuthUri(auth.getCurrentUri());
});

_defineProperty(Bridge, "hasSSOToken", function (auth) {
  return auth && auth.hasSSOToken();
});

export default Bridge;
//# sourceMappingURL=bridge.js.map